import { render, staticRenderFns } from "./FeaturesList.vue?vue&type=template&id=1830b904&scoped=true"
import script from "./FeaturesList.vue?vue&type=script&lang=js"
export * from "./FeaturesList.vue?vue&type=script&lang=js"
import style0 from "./FeaturesList.vue?vue&type=style&index=0&id=1830b904&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1830b904",
  null
  
)

export default component.exports